import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useLanguage } from '@/contexts/LanguageContext';

interface DrinkInfoModalProps {
  open: boolean;
  onClose: () => void;
}

export function DrinkInfoModal({ open, onClose }: DrinkInfoModalProps) {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{t('drinkInfoTitle')}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm">
          <div className="space-y-1">
            <p>{t('drinkInfoBeer')}</p>
            <p>{t('drinkInfoWine')}</p>
            <p>{t('drinkInfoShot')}</p>
          </div>
          
          <div className="pt-2 border-t border-border">
            <p className="text-muted-foreground">
              <strong>{t('drinkInfoRule')}</strong> {t('drinkInfoRuleText')}
            </p>
          </div>
          
          <div className="pt-2 border-t border-border space-y-3">
            <p className="font-medium">{t('drinkInfoExamples')}</p>
            
            <div className="space-y-1 text-muted-foreground">
              <p>{t('drinkInfoExample1')}</p>
              <p className="pl-4">{t('drinkInfoExample1Result')}</p>
            </div>
            
            <div className="space-y-1 text-muted-foreground">
              <p>{t('drinkInfoExample2')}</p>
              <p className="pl-4">{t('drinkInfoExample2Result')}</p>
            </div>
            
            <div className="space-y-1 text-muted-foreground">
              <p>{t('drinkInfoExample3')}</p>
              <p className="pl-4">{t('drinkInfoExample3Result')}</p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
